import { Component, OnInit } from '@angular/core';
import { AnalyticsService } from 'src/app/global/services/analytics.service';
import { AccountService } from 'src/app/pages/account/services/account.service';
import { environment } from 'src/environments/environment.prod';
import { ExtendedModule } from '@angular/flex-layout/extended';
import { FlexModule } from '@angular/flex-layout/flex';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'app-copyright',
    templateUrl: './copyright.component.html',
    styleUrls: ['../footer.component.scss'],
    standalone: true,
    imports: [FlexModule, ExtendedModule, MatIconModule, MatButtonModule, CommonModule]
})
/**
 * Copyright Component
 * This component is responsible for displaying copyright information
 * and links to terms and conditions, privacy policy, and cookie settings.
 */
export class CopyrightComponent implements OnInit {
	// Localized strings for terms and conditions and privacy policy
	termsAndCondition = $localize`:@@donation_form_terms&conditions:terms-and-conditions`;
	privacy = $localize`:@@footer_privacy_and_cookies_url:privacy-and-cookies`;

	// URLs for terms and conditions, privacy policy, and copyright
	termsHref: any;
	privacyHref: any;
	copyrightHref: any;

	// Current locale of the user
	currentLocale: string = '';

	constructor(
		private _accountService: AccountService, // Service to get account-related information
		private analyticsService: AnalyticsService // Service to handle analytics-related actions
	) {}

	ngOnInit(): void {
		// Get the current locale from the account service
		this.currentLocale = this._accountService.getLocaleId();

		// Construct URLs for terms and conditions, privacy policy, and copyright based on the current locale
		this.termsHref = `${environment.homeUrl}/${this.currentLocale}/${this.termsAndCondition}/`;
		this.privacyHref = `${environment.homeUrl}/${this.currentLocale}/${this.privacy}/`;
		this.copyrightHref = `${environment.homeUrl}/${this.currentLocale}/`;
	}

	// Method to open cookie settings using the analytics service
	openCookieSettings() {
		this.analyticsService.openCookieSettings();
	}
}
